import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    List,
    Box,
    CircularProgress
} from '@mui/material';
import { styled } from '@mui/system';
import Comment from './Comment';
import CommentForm from './CommentForm';

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        backgroundColor: '#f2f2f2',
        border: '1px solid #FFFFFF00',
        borderRadius: '20px',
    },
}));

const Comments = ({ postId, userEmail, userPicture, handleClose, likedComments }) => {
    const [comments, setComments] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchComments = async () => {
            try {
                const response = await fetch('/.netlify/functions/getComments', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ postId, userEmail }),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error ${response.status}`);
                }

                const data = await response.json();

                setComments(data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching comments:', error);
            }
        };

        fetchComments();
    }, [postId, userEmail]);

    const handleCommentAdded = (newComment) => {
        setComments(prevComments => [...prevComments, newComment]);
    };

    return (
        <StyledDialog open={true} onClose={handleClose}>
            <DialogTitle
                sx={{
                    color:'#333333'
                }}
            >
                Comments
            </DialogTitle>
            <DialogContent>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <List>
                        {comments.map(comment => (
                            <Comment
                                key={comment.id}
                                {...comment}
                                userEmail={userEmail}
                                userPicture={userPicture}
                                postId={postId}
                                isLiked={likedComments[comment.id]}
                                likeCount={typeof comment.likeCount === 'object' ? (comment.likeCount.low || 0) : (comment.likeCount || 0)}
                            />
                        ))}
                    </List>
                )}
                <CommentForm
                    postId={postId}
                    userEmail={userEmail}
                    onCommentAdded={handleCommentAdded}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </StyledDialog>
    );
};

export default Comments;
